import { useState } from "react"
import { makeStyles } from "tss-react/mui"
import { Typography } from "@mui/material"
import { LocalizedEnum, LocalizedStrict } from "../../../localization/components/AppLocalized"
import {
    DeviceDetailsBox,
    DeviceDetailsHeaderBox,
    DeviceDetailsInfoItem,
    DeviceDetailsItemRow,
    DeviceDetailsSectionBox,
    DeviceDetailsSectionTable,
    DeviceStatusChip,
} from "./DeviceDetailsDialogElements"
import { DeviceDetailsGroup } from "../deviceTypes"
import { StandardChip } from "../../../../shared/components/badges/StandardChip"

const useStyles = makeStyles()((theme) => ({
    sectionBox: {
        display: "grid",
        gap: "1.2rem",
    },
    infoWrap: {
        display: "grid",
        gridTemplateColumns: "14px 1fr",
        gap: "10px",
    },
    infoIcon: {
        color: theme.palette.tailwind.sky[500],
    },
}))

type DeviceDetailsDialogGroupSectionProps = Readonly<{
    deviceGroup: DeviceDetailsGroup
}>

export function DeviceDetailsDialogGroupSection({ deviceGroup }: DeviceDetailsDialogGroupSectionProps) {
    const { name, devices } = deviceGroup
    const { classes } = useStyles()
    const [expanded, setExpanded] = useState<boolean>(true)

    return (
        <DeviceDetailsBox>
            <LocalizedStrict id="device-details-group-info-title" attrs={{ title: true }}>
                <DeviceDetailsHeaderBox title="Group">
                    <StandardChip variant="info">{name}</StandardChip>
                </DeviceDetailsHeaderBox>
            </LocalizedStrict>
            <DeviceDetailsSectionBox updateClasses={classes.sectionBox}>
                <DeviceDetailsSectionTable>
                    <LocalizedStrict id="device-details-group-info-connected-devices" attrs={{ label: true }}>
                        <DeviceDetailsInfoItem label="Connected devices:" hideLastRow />
                    </LocalizedStrict>
                </DeviceDetailsSectionTable>
                <DeviceDetailsSectionTable
                    headElements={
                        <>
                            <LocalizedStrict id="device-details-group-table-header-name">
                                <span>Name</span>
                            </LocalizedStrict>
                            <LocalizedStrict id="device-details-group-table-header-type">
                                <span>Type</span>
                            </LocalizedStrict>
                            <LocalizedStrict id="device-details-group-table-header-status">
                                <span>Status</span>
                            </LocalizedStrict>
                        </>
                    }
                >
                    {devices.map((el, index) => (
                        <DeviceDetailsItemRow key={index}>
                            <Typography>{el.name}</Typography>
                            <LocalizedEnum base="device-details-type-mode" enumValue={el.type}>
                                <Typography>{el.type}</Typography>
                            </LocalizedEnum>
                            <DeviceStatusChip status={el.statusDetails.status} />
                        </DeviceDetailsItemRow>
                    ))}
                </DeviceDetailsSectionTable>
            </DeviceDetailsSectionBox>
        </DeviceDetailsBox>
    )
}
